import { useEffect, useRef, useState } from "react";
import { style } from "./StyleType";
import { DatepickerComponent, FormControl, Helper, InputWrapper, Label, Wrapper } from "./Style";
import { createGlobalStyle } from "styled-components";
import useOutsideClick from "../../../helpers/Datepicker/useOutsideClick";
import { ReactComponent as ChevronRightSVG } from "../../../assets/icons/seta_direcional_direita.svg";
import { ReactComponent as ChevronLeftSVG } from "../../../assets/icons/seta_direcional_esquerda.svg";
import { ReactComponent as IconCalendario } from "../../../assets/icons/calendario.svg";
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale } from "react-datepicker";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import TmpButtonGroupCustom from "../TmpButtonGroupCustom/TmpButtonGroupCustom";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import TmpTypographyCustom from "../TmpTypographyCustom/TmpTypographyCustom";
import TmpButtonIconCustom from "../TmpButtonIconCustom/TmpButtonIconCustom";

interface TmpDatepickerCustomProps {
    name: string;
    label: string;
    placeholder: string;
    error?: boolean;
    value?: any;
    disabled?: boolean;
    maxDate?: any;
    helperIcon?: "info" | "error";
    helperText?: string;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}

const GlobalStyle = createGlobalStyle`
  * {
    scroll-behavior: smooth;
  }
`;

registerLocale('pt-BR', ptBR)

export default function TmpDatepickerCustom(props: TmpDatepickerCustomProps) {

    const [_keyboardFocus, setKeyboardFocus] = useState(false);
    const [_inputFocus, setInputFocus] = useState(false);
    const [_isOpen, setIsOpen] = useState(false);
    const refWrapper = useRef<HTMLInputElement>(null);
    const [dateValue, setDateValue] = useState(null);
    const [auxDateValue, setAuxDateValue] = useState(null);
    const [auxInputDateLengthValue, setAuxInputDateLengthValue] = useState<number>(0);

    useEffect(() => {
        if (!props.value || props.value.toString() === "") {
            setDateValue(null)
            setAuxDateValue(null);
        } else {
            
            if (Object.prototype.toString.call(props.value) === "[object Date]") {
                if (isNaN(props.value)) {
                    setDateValue(null)
                    setAuxDateValue(null);   
                }else{
                    setDateValue(props.value) 
                    setAuxDateValue(props.value);   
                }
            }else{
                setDateValue(props.value)
                setAuxDateValue(props.value);   
            }
        }
    }, [props.value]);

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    const _handleAction = (action: any) => {
        if (action === "confirm") {
            props.onChange(convertToDefEventPara(props.name, dateValue))
        } else {
            setDateValue(auxDateValue);
            props.onChange(convertToDefEventPara(props.name, auxDateValue))
        }
        setIsOpen(false);
        setInputFocus(false);
        setKeyboardFocus(false);
    };

    // Events
    const _handleKeyBoardEvents = (e: any) => {
        if (e.code === "Tab") {
            setKeyboardFocus(true);
        }
    };

    const _handleFocus = (e: any) => {
        // ScrollToDatePicker();
        setInputFocus(true);
    };

    const _openDatepicker = (status: any) => {
        setIsOpen(true);
        setAuxDateValue(dateValue);
        setInputFocus(status);
        setKeyboardFocus(status);
        if (status === true) {
            //props.handleOpenDatepicker(status);
        }
    };

    useOutsideClick(refWrapper, (e: any) => {
        if(_isOpen){
            setIsOpen(false); 
            setDateValue(auxDateValue);
            props.onChange(convertToDefEventPara(props.name, auxDateValue))
        }
    });

    const handleDateBlur = (date: any) => {
        if (date === null || date === undefined) {
            props.onChange(convertToDefEventPara(props.name, null))
        } else if ((date == null || date === undefined) && date?.target?.value === "") {
            date.target.value = null
            props.onChange(date)
        }
        setInputFocus(false);
        setKeyboardFocus(false);

    };


    const handleChangeRaw = (date: any) => {

        if (date.currentTarget.value !== null && date.currentTarget.value !== undefined && date.currentTarget.value !== "") {

            var inputDateLengthActual = date.currentTarget.value.length;
            var isRemoveCharacters = inputDateLengthActual <= auxInputDateLengthValue;
             
            if (date.currentTarget.value.length === 2 && !isRemoveCharacters) {
                date.currentTarget.value = date.currentTarget.value + "/"
            }

            if (date.currentTarget.value.length === 5 && !isRemoveCharacters) {
                date.currentTarget.value = date.currentTarget.value + "/"
            }

            if (date.currentTarget.value.length === 10) {

                var parts = date.target.value.split('/');

                if (parseInt(parts[1]) <= 12 && parseInt(parts[0]) <= 31) {
                    var dateConverted = new Date(parts[2], parts[1] - 1, parts[0]);
                    props.onChange(convertToDefEventPara(props.name, dateConverted))
                }else{
                    props.onChange(convertToDefEventPara(props.name,  new Date("invalid")))
                }

            }else{
                props.onChange(convertToDefEventPara(props.name,  new Date("invalid")))
            }

            setAuxInputDateLengthValue(date.currentTarget.value.length);
        }else if(date !== undefined && date.type !== "click"){
            props.onChange(convertToDefEventPara(props.name, undefined))
        }

    };

    
    // Passing style props to styled component
    Wrapper.defaultProps = style;
    FormControl.defaultProps = style;
    Label.defaultProps = style;
    Helper.defaultProps = style;
    InputWrapper.defaultProps = style;
    DatepickerComponent.defaultProps = style;

    return (
        <Wrapper>
            <GlobalStyle />
            <FormControl
                tabFocus={_keyboardFocus}
                focus={_inputFocus}
                onKeyUp={_handleKeyBoardEvents}
                error={props.error ? true : false}
                disabled={props.disabled ? true : false}>

                <div className="tabFocus">
                    <Label htmlFor={props.name}>{props.label}</Label>
                    <InputWrapper className="input-wrapper" ref={refWrapper}  >
                        <DatepickerComponent
                            open={_isOpen}
                            placeholderText={props.placeholder}
                            showPopperArrow={false}
                            locale="pt-BR"
                            onKeyDown={(e) => {
                                if (e.key === "Tab") {
                                    handleDateBlur(dateValue);
                                }
                            }}
                            onChangeRaw={(e) => handleChangeRaw(e)}
                            formatWeekDay={(day) => day.substring(0, 1)}
                            renderCustomHeader={({
                                monthDate,
                                customHeaderCount,
                                decreaseMonth,
                                increaseMonth,
                            }) => (
                                <div>
                                    <TmpButtonIconCustom
                                        typeButton="button"
                                        type="primary"
                                        icon={<ChevronLeftSVG />}
                                        size="sm"
                                        handleClick={decreaseMonth}
                                    />
                                    <span className="react-datepicker__current-month">
                                        <TmpTypographyCustom
                                            component="heading"
                                            variant="h6"
                                            id="teto-datas"
                                            size="small"
                                        >
                                            {monthDate.toLocaleString("pt-BR", {
                                                month: "long",
                                                year: "numeric",
                                            })}
                                        </TmpTypographyCustom>
                                    </span>
                                    <TmpButtonIconCustom
                                        typeButton="button"
                                        type="primary"
                                        icon={<ChevronRightSVG />}
                                        size="sm"
                                        handleClick={increaseMonth}
                                    />
                                </div>
                            )}
                            dateFormat={"dd/MM/yyyy"}
                            disabled={props.disabled}
                            selected={dateValue}
                            onFocus={_handleFocus}
                            onBlur={handleDateBlur}
                            onChange={(date: any) => {setDateValue(date)}}
                        >
                            <TmpButtonGroupCustom
                                labelPrimary="Confirmar"
                                size="sm"
                                labelSecondary="Cancelar"
                                handleClickPrimary={() => _handleAction("confirm")}
                                handleClickSecondary={() => _handleAction("cancel")}
                            />
                        </DatepickerComponent>
                        <TmpIconCustom
                            icon={<IconCalendario />}
                            size="md"
                            onClick={() => _openDatepicker(true)}
                        />
                    </InputWrapper>
                </div>
                <Helper >
                    {props.helperIcon === "error" && props.error &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconError />} />
                        </span>
                    }
                    {props.helperIcon === "info" &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconInfo />} />
                        </span>
                    }
                    {props.helperText}

                </Helper>
            </FormControl>
        </Wrapper>
    );
}
